import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    get<T>(key: string): T {
        const data = sessionStorage.getItem(key);
        return data ? JSON.parse(data) : null;
    }

    set<T>(key: string, value: T): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    remove(key: string): void {
        sessionStorage.removeItem(key);
    }

    clear(): void {
        sessionStorage.clear();
    }
}
